import { useSelector } from 'react-redux';
import { formError } from './selectors';

export const useFormError = id => useSelector(formError(id));
